export const sites = ["investor", "main"] as const;
export type Site = typeof sites[number];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isSite = (string: any): string is Site => sites.includes(string);
